<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">项目基本信息</h3>
        <a-descriptions v-for="(item,key) in form" style="border-bottom:1px dashed #bbb;margin-bottom:10px" :key="key" size="middle" :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }">
            <a-descriptions-item label="开始时间" name="startTime">{{item.startTime}}</a-descriptions-item>
            <a-descriptions-item label="结束时间" name="endTime">{{item.endTime}}</a-descriptions-item>
            <a-descriptions-item :span="2" label="实施内容和目标（承担单位实施内容和目标）" name="contentObjectives">{{item.contentObjectives}}</a-descriptions-item>
            <a-descriptions-item :span="2" label="合作(协作)单位实施内容和目标" name="collaborateContentObjectives">{{item.collaborateContentObjectives}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>

    import { projectImplementation } from "@/api/TechnologieprojekteApply";
    import {
        formMixin
    } from "@/mixins";
    export default {
        name: "项目基本信息",
        mixins: [formMixin],
        components: {
        },
        data() {
            return {
                options: null,
                form:{
                },
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectImplementation.selectList,
                    params: { 
                        projectId: this.$route.query.projectId
                     }
                }).then((res) => {
                    this.form = res
                });
            }
        }

    }
</script>
